import * as React from 'react';
import { observer } from 'mobx-react';
import { autoinject, inject } from '../Utils/AutoInject';
import { CommonAppStore } from '../Utils/CommonAppStore';
import { LoadScript } from '@react-google-maps/api';
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import { bind } from '../Utils/Bind';
import { action } from 'mobx';
import { Loader } from './Loader';

const libraries = ['places', 'geometry', 'drawing'] as Libraries;

export interface ILoadGoogleMapScript {
    readonly googleMapApiKey?: string;
    readonly loadingElement?: React.ReactNode;
}

// This component serves 2 purposes
// 1. googleMapApiKey == '1235-125'
//      a. Trigger <LoadScript>
//      b. set commonAppStore.googleMapsLoaded
// 2. googleMapApiKey == undefined
//      a. render Loader
//      b. set this.commonAppStore.loadGoogleMaps
@autoinject
@observer
export class LoadGoogleMapScript extends React.Component<ILoadGoogleMapScript> {
    @action
    public componentDidMount() {
        // If googleMapApiKey was passed in as undefined, That means we should trigger a load
        if (this.props.googleMapApiKey == undefined) this.commonAppStore.loadGoogleMaps = true;
    }

    public render() {
        const { googleMapApiKey, loadingElement, children } = this.props;
        const { googleMapsLoaded, loadGoogleMaps } = this.commonAppStore;

        if (googleMapApiKey) {
            return (
                <LoadScript googleMapsApiKey={googleMapApiKey} libraries={libraries} onLoad={this.onLoad}>
                    {children}
                </LoadScript>
            );
        } else {
            return googleMapsLoaded ? children : loadingElement || <Loader loading />;
        }
    }

    @bind
    @action
    private onLoad() {
        this.commonAppStore.googleMapsLoaded = true;
    }

    @inject
    private readonly commonAppStore!: CommonAppStore;
}
